import { useState } from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { ConditionTab } from '@/components/Analysis/Insights/InsightsExplorer/PaintBlock/Summary/style';
import { CoatingConditionGraph } from './CoatingConditionGraph';
import { ComponentHealthGraph } from './ComponentHealthGraph';
import { TemporalAnalysisFilterCapsules } from './TemporalAnalysisGraphs/TemporalAnalysisFilterCapsules';

type Props = {
  activeDeploymentIds: string[];
};

export const TemporalAnalysisGraphsContainer = ({ activeDeploymentIds }: Props) => {
  const [selectedConditionType, setSelectedConditionType] = useState('coating_condition');
  const [selectedDeployments, setSelectedDeployments] = useState<string[]>([]);
  const [filteredSelectedDeployments, setFilteredSelectedDeployments] = useState<string[]>([]);
  return (
    <>
      <Box sx={{ paddingBottom: 6 }}>
        <Stack direction="row" alignItems="center">
          <Stack direction="row" mr={2}>
            <ConditionTab
              selected={selectedConditionType === 'coating_condition'}
              onClick={() => {
                setSelectedConditionType('coating_condition');
                setSelectedDeployments([]);
              }}
            >
              <Typography fontSize="1.2rem" fontWeight={600}>
                Coating Condition
              </Typography>
            </ConditionTab>
          </Stack>
          <Stack direction="row" my={3} mr={2}>
            <ConditionTab
              selected={selectedConditionType === 'component_health'}
              onClick={() => {
                setSelectedConditionType('component_health');
                setSelectedDeployments([]);
              }}
            >
              <Typography fontSize="1.2rem" fontWeight={600}>
                Component Health
              </Typography>
            </ConditionTab>
          </Stack>
          <Divider orientation="vertical" flexItem sx={{ height: '2.5rem', alignSelf: 'center' }} />
          <Stack mx={2} direction="row" alignItems="center">
            <Box ml={1}>
              <TemporalAnalysisFilterCapsules
                data={selectedDeployments}
                setFilteredSelectedDeployments={setFilteredSelectedDeployments}
              />
            </Box>
          </Stack>
        </Stack>

        {selectedConditionType === 'coating_condition' && (
          <CoatingConditionGraph
            activeDeploymentIds={activeDeploymentIds}
            setSelectedDeployments={setSelectedDeployments}
            selectedDeployments={filteredSelectedDeployments}
          />
        )}

        {selectedConditionType === 'component_health' && (
          <ComponentHealthGraph
            setSelectedDeployments={setSelectedDeployments}
            selectedDeployments={filteredSelectedDeployments}
          />
        )}
      </Box>
    </>
  );
};